import Cookies from 'cookies-js';
/**
 * Class will be exposed and be in charge of managing the ```session```, checking if user is logged
 * in and managing the login data.
 */
class SessionManagerService {
  constructor() {
    /**
     * Initiliaze login data object
     * @type {Object}
     */
    this.loginData = {};
  }
  /**
   * It locally stores the login data object
   * @param {Object} loginData Object containing usar data
   * @property {String}  displayName User's display name
   * @property {String}  fistName    User's firstname
   * @property {String}  lastName    User's lastname
   * @property {String}  email       User's email
   * @property {Boolean} rememberMe  Flag to tell if `remember me` is checked.
   * @property {Number}  userID      User identification number
   */
  setLoginData(loginData) {
    this.loginData = loginData;
  }
  /**
   * Returns the locally store login data object
   * @returns {Object}
   */
  getLoginData() {
    return this.loginData;
  }
  /**
   * Check if the user is logged in by reading a cookie value.
   * @returns {Boolean}
   */
  isLoggedIn() {
    return Cookies.get('loggedIn') === 'true';
  }

  /**
   * Return userToken if its already set.
   * @returns {string}
   */
  getUserToken() {
    return Cookies.get('user_token');
  }
}

export default new SessionManagerService();



// WEBPACK FOOTER //
// ./src/services/SessionManager.js